export default "__VITE_ASSET__CWq$hYNV__"